import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { Shield } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
interface ArsenalItem {
  cover?: string;
  title: string;
  subtitle: string;
  desc: string;
  value: string;
}
export function ArsenalSection() {
  const items: ArsenalItem[] = [{
    cover: 'https://cdn.magicpatterns.com/uploads/daztqiWmen7ceve4wfF7Ps/COVER.png',
    title: 'L\u2019Algorithme de l\u2019Amour',
    subtitle: 'Ebook Principal',
    desc: 'Le guide intégral pour dominer la psychologie du dating digital.',
    value: 'Valeur 47$'
  }, {
    title: "Le Protocole 'Identity Shift'",
    subtitle: "Plan d'action 21 jours",
    desc: "Ton plan d'action quotidien pour passer du mode 'option' au mode 'priorité'.",
    value: 'Inclus dans le ebook'
  }, {
    cover: 'https://cdn.magicpatterns.com/uploads/gAdVafEEb7rYzEbUhvTirs/COVER_BONUS_1.png',
    title: 'Le Lexique Secret',
    subtitle: 'Bonus #1',
    desc: "50 phrases exactes à copier-coller pour recadrer les paresseux et décrocher le 'Date'.",
    value: 'Valeur 27$'
  }, {
    cover: 'https://cdn.magicpatterns.com/uploads/nUKpe8GUUrRK5DwPfik4Wk/COVER_BONUS_2.png',
    title: 'Le Détecteur de Cons',
    subtitle: 'Bonus #2',
    desc: "Comment identifier un narcissique ou un 'Time-Waster' en seulement 3 messages.",
    value: 'Valeur 27$'
  }];
  return <section className="py-16 md:py-32 bg-deep-black relative" data-id="element-12">
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-champagne-gold/5 rounded-full blur-[150px]" data-id="element-13"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-14">
        {/* Animated arrow indicator */}
        <FadeIn data-id="element-15">
          <div className="flex flex-col items-center mb-10" data-id="element-16">
            <motion.div animate={{
            y: [0, 12, 0]
          }} transition={{
            repeat: Infinity,
            duration: 1.5,
            ease: 'easeInOut'
          }} className="flex flex-col items-center gap-1" data-id="element-17">
              <span className="text-champagne-gold text-xs tracking-[0.2em] uppercase font-semibold" data-id="element-18">
                Découvre ce que tu reçois
              </span>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-19">
                <path d="M12 5v14M5 12l7 7 7-7" data-id="element-20" />
              </svg>
            </motion.div>
          </div>
        </FadeIn>

        <FadeIn data-id="element-21">
          <div className="text-center mb-20" data-id="element-22">
            <span className="text-champagne-gold text-xs font-semibold tracking-[0.2em] uppercase mb-4 block" data-id="element-23">
              Ton Arsenal
            </span>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream" data-id="element-24">
              Ce Que Tu Reçois{' '}
              <span className="italic text-champagne-gold" data-id="element-25">Immédiatement</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-5 md:gap-8" data-id="element-26">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-27">
              <div className="group relative bg-glass-burgundy backdrop-blur-sm border border-burgundy/40 hover:border-champagne-gold/50 rounded-3xl p-5 md:p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-burgundy-glow overflow-hidden h-full" data-id="element-28">
                <div className="absolute top-0 right-0 w-32 h-32 bg-champagne-gold/5 rounded-bl-full transition-transform duration-500 group-hover:scale-150" data-id="element-29"></div>

                <div className="relative z-10 flex flex-col items-center text-center gap-6" data-id="element-30">
                  {item.cover ? <div className="relative flex-shrink-0" data-id="element-31">
                      <div className="absolute -inset-3 bg-champagne-gold/8 rounded-2xl blur-xl" data-id="element-32"></div>
                      <img src={item.cover} alt={item.title} className="relative w-40 md:w-48 rounded-xl shadow-lg shadow-champagne-gold/10 border border-champagne-gold/15 transition-transform duration-500 group-hover:scale-105" data-id="element-33" />
                    </div> : <div className="p-5 bg-deep-black/50 rounded-2xl border border-champagne-gold/20" data-id="element-34">
                      <Shield className="w-10 h-10 text-champagne-gold" data-id="element-35" />
                    </div>}
                  <div data-id="element-36">
                    <div className="text-xs text-champagne-gold tracking-widest uppercase mb-2 font-semibold" data-id="element-37">
                      {item.subtitle}
                    </div>
                    <h3 className="font-playfair text-2xl text-cream mb-3" data-id="element-38">
                      {item.title}
                    </h3>
                    <p className="text-muted-cream font-light text-sm leading-relaxed mb-4" data-id="element-39">
                      {item.desc}
                    </p>
                    <div className="inline-block px-3 py-1 bg-burgundy/30 border border-burgundy rounded-full text-xs text-cream font-medium" data-id="element-40">
                      {item.value}
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* CTA below arsenal */}
        <FadeIn delay={0.8} data-id="element-41">
          <div id="arsenal-cta" className="mt-12 md:mt-16 text-center" data-id="element-42">
            <p className="text-lg text-muted-cream mb-2" data-id="element-43">
              VALEUR TOTALE :{' '}
              <span className="line-through decoration-red-500 decoration-2 text-red-400" data-id="element-44">
                101$
              </span>
            </p>
            <p className="mb-8" data-id="element-45">
              <span className="text-xl text-champagne-gold font-playfair italic mr-3" data-id="element-46">
                Ton prix ce soir :
              </span>
              <span className="text-5xl md:text-6xl font-playfair font-bold gold-shimmer" data-id="element-47">
                9,97$
              </span>
            </p>
            <motion.a href="https://redevenirmoi.com/cart/53549720371568:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackAddToCart({
              content_name: "L'Algorithme de l'Amour - L'Effet Obsession",
              content_type: 'product',
              value: 9.97,
              currency: 'USD'
            });
          }} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="block w-full max-w-2xl mx-auto py-6 md:py-7 bg-champagne-gold rounded-full shadow-gold-glow-lg hover:shadow-[0_0_60px_rgba(212,175,55,0.6)] transition-all duration-300 no-underline cursor-pointer text-center" data-id="element-48">
              <span className="text-deep-black font-bold text-lg md:text-2xl uppercase tracking-widest" data-id="element-49">
                OUI, JE VEUX L'EFFET OBSESSION
              </span>
            </motion.a>
            <p className="mt-4 text-muted-cream/70 text-sm font-light tracking-wide" data-id="element-50">
              Téléchargement immédiat • PDF • Smartphone & PC
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}